"use client";
import React, { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import Link from 'next/link';
import Button from '@/components/CommonComponent/button';
import Image from 'next/image';
import axios from 'axios';
import { BASE_URL } from '@/util/api';
import { Pagination } from 'antd';
import { useRouter } from 'next/navigation';
const Category = ({ slug }: any) => {
  const pathname = usePathname();
  const router = useRouter();  // Get the router object from next/navigation
  const segments = pathname!.replace(/\/$/, '').split('/');
  const lastsegment = segments.pop();
  const [descripton, setdescriton] = useState<any>('');
  const [blog, setBlogs] = useState<any>();
  const [totalBlogs, setTotalBlogs] = useState<number>(0);
  const [pages, setPages] = useState<number>(0);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [expandedTitle, setExpandedTitle] = useState<number | null>(null)
  const [expandedSummary, setExpandedSummary] = useState<number | null>(null)
  const fetch = async (page: number = 1) => {
    try {
      const response = await axios.get(`${BASE_URL}blogs/?category=${slug}&page=${page}`);
      if (response?.data?.results.blogs.length == 0) {
        router.push('/not-found');
      }
      setBlogs(response?.data?.results.blogs);
      setdescriton(response.data.results.category_details);
      setTotalBlogs(response.data.count);
      const totalPages = Math.ceil(response.data.count / 10);
      setPages(totalPages);
    }
    catch (error: any) {
      // console.log("client error", error.message);
    }
  };
  function truncateText(text: string, limit: number) {
    if (text.length > limit) {
      return text.substring(0, limit) + '...'
    }
    return text
  }
  useEffect(() => {
    fetch(currentPage);
  }, [currentPage]);
  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  useEffect(() => {
    const scrollTimeout = setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }, 100);
    return () => clearTimeout(scrollTimeout);
  }, [blog]);
  return (
    <div>
      {(<div>
        <div className="w-full xl:w-[95%]  2xl:w-[80%] mx-auto px-4 bg-white">
          <div className="mt-5 py-3 w-full border-b-[2px] border-lightblue">
            <div className="text-homegrey font-medium">
              <Link href={'/blog'}>Blog</Link>/<span className="text-pink capitalize">{lastsegment}</span>
            </div>
          </div>
          {
            descripton?.description &&
            <div className="w-full leading-tight bg-lightblue text-[18px] text-homegrey p-4 md:p-10 mt-3 rounded-2xl">
              <div
                dangerouslySetInnerHTML={{
                  __html: descripton?.description || 'data not available',
                }}
              />
            </div>
          }
          <div className="w-full mt-16">
            <div className="w-full border-b-2 border-lightblue pb-5">
              <h1 className="text-homeblack !text-[38px] font-bold">
                <span className="uppercase">{lastsegment}&nbsp;</span>- Blogs
              </h1>
            </div>
            <div className="flex mt-4 mb-16 justify-center flex-wrap gap-5">
              {blog?.map((elem: any, i: number) => (
                <div key={i} className="relative border-[2px] border-lightblue hover:shadow-xl duration-300 sm:w-[45%] w-[9] lg:w-[32%] pb-2 rounded-lg">
                  <div className="bg-pink absolute top-3 left-3 text-white text-[17px] font-medium rounded-lg py-1 px-4">
                    {elem?.blog_date ? (() => {
                      const date = new Date(elem.blog_date);
                      const day = String(date.getDate()).padStart(2, '0');
                      const month = date.toLocaleString('en-US', { month: 'short' });
                      const year = date.getFullYear();
                      return `${day} ${month}, ${year}`;
                    })() : ''}
                  </div>
                  <div className="text-blue font-medium px-3 py-1 w-fit absolute top-3 right-3 rounded-md bg-lightblue">
                    <Link href={`/blog/${elem?.category?.category_slug}`}>
                      <span>{elem?.category?.name || 'Uncategorized'}</span>
                    </Link>{' '}
                  </div>
                  <div>
                    {
                      elem?.image &&
                      <Image src={elem?.image || ''} unoptimized alt={elem?.image_alt || "alt"} height={218} width={461} className="rounded-lg max-h-[218px]" />
                    }
                  </div>
                  <div className="p-4 flex flex-col  gap-3 justify-between">
                    <p className="font-bold text-homeblack text-[24px] leading-tight cursor-pointer" onClick={() => setExpandedTitle(expandedTitle === i ? null : i)}>
                      {expandedTitle === i ? elem?.title : truncateText(elem?.title, 30)} {/* Truncate title to 30 characters */}
                    </p>
                    <p className="text-homegrey leading-[21px] text-[18px] cursor-pointer" onClick={() => setExpandedSummary(expandedSummary === i ? null : i)}>
                      {expandedSummary === i ? elem?.summary : truncateText(elem?.summary, 60)}
                    </p>
                    <div>
                      <Link href={`/blog/${elem?.category?.category_slug}/${elem?.slug_link}`}>
                        <Button content={'View'}></Button>
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="flex justify-center  mb-6">
            <Pagination
              current={currentPage}
              total={totalBlogs}
              pageSize={10}
              onChange={handlePageChange}
              showTotal={(total) => `Total ${total} blogs`}
            />
          </div>
        </div>
      </div>
      )}
    </div>
  );
};

export default Category;
